import PhoneIcon from "@mui/icons-material/Phone";
import React from "react";
import { Button } from "~/shared/components/MuiComponents.jsx";
import { kickBlue } from "~/shared/styles/baseStyles.js";
import { openCalPopup } from "~/shared/utils/calcomEmbed.js";

export default function SleepConciergeCTA({ userID, email, firstName, phone }) {
  const handleClick = () => {
    openCalPopup("sleep-concierge/introduction", {
      userID: userID || "",
      userEmail: email || "",
      userName: firstName || "",
      userPhone: phone || "",
    });
  };

  return (
    <div
      style={{
        textAlign: "center",
        width: "100%",
        borderBottom: "1px solid #ddd",
        paddingBottom: "28px",
        marginBottom: "20px",
        maxWidth: "800px",
      }}
    >
      <PhoneIcon style={{ fontSize: "36px", color: kickBlue }} />
      <h4
        style={{
          fontWeight: "bold",
          fontSize: "18px",
          marginTop: "8px",
          marginBottom: "4px",
        }}
      >
        Get a free 15-minute call with a Sleep Concierge!
      </h4>
      <p style={{ fontSize: "14px", color: "#666", marginBottom: "16px" }}>
        Our sleep specialists will help you get the most out of your treatment
        plan.
      </p>
      <Button
        onClick={handleClick}
        style={{
          fontWeight: "bold",
          backgroundColor: kickBlue,
          textTransform: "none",
          fontSize: "14px",
          width: "280px",
        }}
      >
        <PhoneIcon style={{ marginRight: "8px", fontSize: "18px" }} />
        Schedule Your Call
      </Button>
    </div>
  );
}
